import { apiSlice } from "./ApiSlice";
import { logout } from '../authentication/authentication-slice';
import { FieldValues } from 'react-hook-form';
import Tags from "./Tags";

export interface LoginForm extends FieldValues {
    email: string;
    password: string;
    rememberMe: boolean;
}

export interface RegisterForm extends RegisterDTO {
    confirmPassword: string;
    server: string; //for displaying server errors
}

export interface RegisterDTO {
    email: string;
    username: string;
    password: string;
}

interface RegisterResponse {
    id: string,
    realm: string,
    username: string,
    email: string,
    emailVerified: true,
    verificationToken: string
}

export interface LoginResponse {
    id: number | null,
    email: string | null,
    username: string,
    guest: boolean,
    tokenType: string,
    accessToken: string,
    expiresIn: number,
    refreshToken?: string
}

export interface UserStats {
    wins: number,
    losses: number,
    recent: {opponent: string, score: number, opponentScore: number, won: boolean, reason: string, ruleset?: string, endedAt: string}[]
    /** Elo per ruleset (ranked frames); missing from older servers, null if it couldn't be read */
    elo?: Record<string, {rating: number, games: number}> | null
}

export interface WhoAmI {
    id: number | null,
    email: string | null,
    username: string,
    guest: boolean,
    stats: UserStats | null
}


export const extendedSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation<LoginResponse, LoginForm>({
            query(body: LoginForm) {
                return {
                    url: "/user/login",
                    method: "POST",
                    credentials: "include",
                    mode: "cors",
                    body
                };
            }
        }),
        guest: builder.mutation<LoginResponse, void>({
            query() {
                return {url: "/user/guest", method: "POST"};
            }
        }),
        whoAmI: builder.query<WhoAmI, string | null>({
            // the arg (username) only keys the cache so a new login refetches
            query: () => ({url: "/whoami"}),
            keepUnusedDataFor: 0,
        }),
        register: builder.mutation<RegisterResponse, RegisterDTO>({
            query(body: RegisterForm) {
                return {
                    url: "/user/signup",
                    method: "POST",
                    body,
                    user: body.username
                }
            }
        }),
        sendLogout: builder.mutation<void, string>({
            query(token) {
                console.log("sendLogout: " + token);
                return {
                    url: "/user/logout",
                    method: "POST",
                    body: { refreshToken: token }
                }
            },
            async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
                try {
                    //const { data } =
                    await queryFulfilled
                    //console.log(data)
                } catch (err) {
                    // logging out locally even if the server can't be reached
                }
                dispatch(logout());
                dispatch(apiSlice.util?.resetApiState());
            }
        })
        // getUserRoles: builder.query<String[], {}>({
        //     query: () => `api/UserProfile/Roles`,
        //     providesTags: [Tags.Roles]
        // })
    })
});

export const {
    useGuestMutation,
    useWhoAmIQuery,
    useLoginMutation,
    useSendLogoutMutation,
    useRegisterMutation,
    // useGetUserRolesQuery
} = extendedSlice;
